import cn from 'classnames';
import * as React from 'react';

import { useCurrency } from '../../../../contexts/CurrencyProvider';
import { InventoryTypesEnum } from '../../../../types/inventories';
import { CopyableButton } from '../../../forms';
import { ItemMetadata, Price } from '../../../index';

import styles from './LowInventoryItem.module.scss';

export interface ILowInventoryItem {
  className?: string;
  iconClassName?: string;
  iconUrl?: string;
  itemId: string;
  title: string;
  price: number;
  currencyCode?: string;
  sku: string;
  count?: number;
  isDigital?: boolean;
  isCustomizable?: boolean;
  type: InventoryTypesEnum;
  isPreorder?: boolean;
  threshold?: number;
}

const LowInventoryItem: React.FC<ILowInventoryItem> = ({
  className,
  iconClassName,
  sku,
  title,
  iconUrl,
  price,
  currencyCode,
  itemId,
  count,
  type,
  isCustomizable,
  isPreorder,
  threshold,
}) => {
  const { getItemPrice } = useCurrency();

  const itemData = React.useMemo(
    () => ({
      item_id: itemId,
      name: title,
      type,
      count,
      item_customization_allowed: isCustomizable,
      preorder_allowed: isPreorder,
      low_stock_threshold: threshold,
    }),
    [itemId, title, type, count, isCustomizable, isPreorder, threshold],
  );

  return (
    <div className={cn(styles.container, className)}>
      <div className={cn(styles.iconInner, iconClassName)}>
        <div className={styles.icon} style={{ backgroundImage: `url(${iconUrl})` }} />
        <ItemMetadata item={itemData} />
      </div>
      <div className={styles.meta}>
        <div className={styles.wrapper}>
          <Price value={getItemPrice({ price, currency_code: currencyCode, type })} className={styles.price} />
          <CopyableButton className={styles.sku} title={sku} value={sku} inline toastLabel="SKU" />
        </div>
        <div className={styles.title}>{title}</div>
      </div>
    </div>
  );
};

export default LowInventoryItem;
